export default __webpack_public_path__ + "static/media/kitchen3-afterK-1440w.a94ef7f0.webp";